import {IRange} from "@pg-design/inputs";

export function stringifySearchFormRooms(rooms: IRange<string | number>): string {
    const lowerIsEmpty = !rooms.lower || rooms.lower === "";
    const upperIsEmpty = !rooms.upper || rooms.upper === "";

    if (lowerIsEmpty && upperIsEmpty) {
        return "";
    }

    if (lowerIsEmpty && rooms.upper && rooms.upper !== "") {
        return rooms.upper.toString();
    }

    if (upperIsEmpty && rooms.lower && rooms.lower !== "") {
        return rooms.lower.toString();
    }

    if (!lowerIsEmpty && !upperIsEmpty && rooms.lower === rooms.upper) {
        return rooms.lower.toString();
    }

    if (!upperIsEmpty && !lowerIsEmpty) {
        return `${rooms.lower.toString()} - ${rooms.upper.toString()}`;
    }

    return "";
}
import {IRange} from "@pg-design/inputs";

export function stringifySearchFormRooms(rooms: IRange<string | number>): string {
    const lowerIsEmpty = !rooms.lower || rooms.lower === "";
    const upperIsEmpty = !rooms.upper || rooms.upper === "";

    if (lowerIsEmpty && upperIsEmpty) {
        return "";
    }

    if (lowerIsEmpty && rooms.upper && rooms.upper !== "") {
        return rooms.upper.toString();
    }

    if (upperIsEmpty && rooms.lower && rooms.lower !== "") {
        return rooms.lower.toString();
    }

    if (!lowerIsEmpty && !upperIsEmpty && rooms.lower === rooms.upper) {
        return rooms.lower.toString();
    }

    if (!upperIsEmpty && !lowerIsEmpty) {
        return `${rooms.lower.toString()} - ${rooms.upper.toString()}`;
    }

    return "";
}
